module.exports = __webpack_public_path__ + "static/media/mojor_logo.be28363e.png";